export { getArrayItemIdFromFieldPath } from './getArrayItemIdFromFieldPath'
